import withAlignment, { Alignment } from './Alignment'

export default withAlignment
export { Alignment }
